import * as React from 'react'
import { observer } from 'mobx-react'
import { TransferProduct, CreateTransferBatch } from '@getgreenline/homi-shared'
import { message } from 'antd'
import { TransferStore } from '../../TransferStore'

interface Props {
  transferProduct: TransferProduct
  transferStore?: TransferStore
}

export const TransferBatchOptionTable = observer((props: Props) => {
  const { transferProduct, transferStore } = props
  const batchOptions = transferProduct.batchOptions

  const addedTransferBatchIds = transferProduct.batches.map((batch) => batch.batchId)
  const availableBatchOptions = batchOptions.filter(
    (batchOption) => !addedTransferBatchIds.includes(batchOption.batchId),
  )

  const onBatchQuantityChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    batch: CreateTransferBatch,
  ) => {
    const quantity = parseInt(e.target.value)
    batch.setQuantity(isNaN(quantity) ? undefined : quantity)
  }

  const addBatch = (batch: CreateTransferBatch) => {
    if (batch.quantity === undefined) {
      return message.error(`Invalid quantity for Lot number ${batch.batchNumber}`)
    }
    transferProduct.addBatch(batch)

    // Product quantity must be equal to the sum of its batch quantities
    transferProduct.setQuantity(transferProduct.sumBatchQuantity)
  }

  return (
    <table className='table table-sm'>
      <thead className='thead-light'>
        <tr>
          <th>Lot number</th>
          <th>Source stock</th>
          <th>Dest stock</th>
          <th>Quantity</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        {availableBatchOptions.map((batch, index) => {
          return (
            <tr key={index}>
              <td style={{ maxWidth: 400 }}>{batch.batchNumber}</td>
              <td>{batch.fromLocationInventory}</td>
              <td>{batch.toLocationInventory}</td>
              <td>
                <div className='input-group input-group-sm col-md-6 col-5'>
                  <input
                    className={
                      'form-control form-control-sm ' +
                      (transferProduct.quantity === null ? 'border-danger' : '')
                    }
                    type='number'
                    value={batch.quantity === undefined ? '' : batch.quantity}
                    name='transfer-quantity'
                    onChange={(e) => onBatchQuantityChange(e, batch)}
                    min={0}
                  />
                  <div className='input-group-append'>
                    <div className='input-group-text'>{transferProduct.unit || 'unit'}s</div>
                  </div>
                </div>
              </td>

              <td>
                <button
                  className='btn btn-light batch-save-button'
                  onClick={() => {
                    addBatch(batch)
                    transferStore!.hasUnsavedChanges = true
                  }}
                >
                  Add lot
                </button>
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
})
